import { HTTP } from "@/api";

export default {
  getAppSettings({ commit }) {
    return HTTP.get("/settings").then(res => {
      let data = res.data;
      if (data.success) commit("setAppSettings", data.result);
      return !!data;
    });
  },
  saveAppSettings(store, settings) {
    return HTTP.post("/settings", settings);
  }
};
